// extracted by mini-css-extract-plugin
export default {"page":"myOrders_page__NcYWr","pageContent":"myOrders_pageContent__a246W"};